(function(angular) {
  'use strict';

  angular.module('esn.availability')
    .constant('ESN_AVAILABILITY_RESOURCE_TYPE', {
      EMAIL: 'email'
    });
})(angular);
